<template>
  <page-list
    :list="list"
    :columns="templateListColumns || columns"
    :single-actions="singleActions"
    :group-actions="groupActions"
    :export-data-options="exportDataOptions"
    :showSearchbox="showSearchbox"
    :show-group-actions="showGroupActions"
    :show-single-actions="!isTemplate"
    :show-page="!isTemplate">
    <template v-if="!isTemplate" v-slot:table-prepend>
      <div class="analysis-alarm-list-total d-flex mt-2 mb-1">
        <div class="analysis-alarm-list-total-item">
          <span class="analysis-alarm-list-total-item-label">{{ $t('bill.day_record_count') }}：</span>
          <span class="analysis-alarm-list-total-item-value">{{ day_record_count }}</span>
        </div>
        <div class="analysis-alarm-list-total-item ml-2">
          <span class="analysis-alarm-list-total-item-label">{{ $t('bill.month_record_count') }}：</span>
          <span class="analysis-alarm-list-total-item-value">{{ month_record_count }}</span>
        </div>
      </div>
    </template>
  </page-list>
</template>

<script>
import * as R from 'ramda'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import {
  getNameFilter,
  getDescriptionFilter,
  // getCreatedAtFilter,
  getDistinctFieldFilter,
  getEnabledFilter,
} from '@/utils/common/tableFilter'
import expectStatus from '@/constants/expectStatus'
import { getEnabledSwitchActions } from '@/utils/common/tableActions'
import ResTemplateListMixin from '@/mixins/resTemplateList'
import GlobalSearchMixin from '@/mixins/globalSearch'
import ColumnsMixin from '../mixins/columns'
import SingleActionMixin from '../mixins/singleActions'

export default {
  name: 'AnalysisAlarmList',
  mixins: [WindowsMixin, ListMixin, GlobalSearchMixin, ColumnsMixin, SingleActionMixin, ResTemplateListMixin],
  props: {
    id: String,
    getParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'bill_analysis_alarms',
        apiVersion: 'v1',
        getParams: this.getParam,
        filterOptions: {
          name: getNameFilter(),
          description: getDescriptionFilter(),
          domain: getDistinctFieldFilter({
            label: this.$t('table.title.domain'),
            type: 'extra_field',
            field: 'project_domain',
            multiple: true,
            filter: true,
            formatter: val => {
              const list = val.map(key => `"${key}"`)
              return `project_domain.in(${list.join(',')})`
            },
            // getParams: { $t: uuid() },
          }),
          project: getDistinctFieldFilter({
            label: this.$t('dictionary.project'),
            type: 'extra_field',
            field: 'project',
            multiple: true,
            filter: true,
            formatter: val => {
              const list = val.map(key => `"${key}"`)
              return `project.in(${list.join(',')})`
            },
            // getParams: { $t: uuid() },
          }),
          view_scope: {
            label: this.$t('common.text00118'),
            dropdown: true,
            items: [
              { label: this.$t('bill.project_view'), key: 'project' },
              { label: this.$t('bill.domain_view'), key: 'domain' },
              { label: this.$t('bill.system_view'), key: 'system' },
            ],
          },
          time_range: {
            label: this.$t('bill.text_198'),
            dropdown: true,
            items: [
              { key: 'DOD PC', label: this.$t('bill.dod_pc') },
              { key: 'DoD', label: this.$t('bill.dod') },
              { key: 'MoM PC', label: this.$t('bill.mom_pc') },
              { key: 'MoM', label: this.$t('bill.mom') },
            ],
          },
          enabled: getEnabledFilter(),
          // created_at: getCreatedAtFilter(),
        },
        steadyStatus: Object.values(expectStatus.analysisAlarm).flat(),
        fetchDataCb: this.getTotal,
        isTemplate: this.isTemplate,
        templateLimit: this.templateLimit,
      }),
      day_record_count: 0,
      month_record_count: 0,
      groupActions: [
        ...getEnabledSwitchActions(this, undefined, ['bill_analysis_alarms_perform_enable', 'bill_analysis_alarms_perform_disable'], {
          metas: [
            () => {
              const isEnable = !!this.list.selectedItems.find(item => item.enabled)
              return {
                validate: this.list.selectedItems.length && !isEnable,
              }
            },
            () => {
              const isDisable = !!this.list.selectedItems.find(item => !item.enabled)
              return {
                validate: this.list.selectedItems.length && !isDisable,
              }
            },
          ],
          resourceName: this.$t('bill.analysis_cost_alarm'),
        }),
        {
          label: this.$t('common.delete'),
          permission: 'bill_analysis_alarms_delete',
          action: () => {
            const data = this.list.selectedItems
            this.createDialog('DeleteResDialog', {
              vm: this,
              data,
              columns: this.columns,
              title: this.$t('common.delete'),
              name: this.$t('bill.analysis_report'),
              onManager: this.onManager,
            })
          },
          meta: () => {
            return {
              validate: this.list.selectedItems.length > 0,
            }
          },
        },
      ],
    }
  },
  computed: {
    exportDataOptions () {
      return {
        downloadType: 'local',
        title: this.$t('bill.analysis_cost_alarm'),
        items: this.columns,
      }
    },
  },
  created () {
    this.fetchData()
  },
  methods: {
    getParam () {
      const ret = {
        ...(R.is(Function, this.getParams) ? this.getParams() : this.getParams),
      }
      return ret
    },
    fetchData () {
      this.list.fetchData()
    },
    getTotal (response) {
      const { totals = {} } = response.data
      const { day_record_count = 0, month_record_count = 0 } = totals
      this.day_record_count = day_record_count
      this.month_record_count = month_record_count
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'BillAnalysisAlarmSidePage', {
        id: row.id,
        resource: 'bill_analysis_alarms',
        getParams: this.getParam,
      }, {
        list: this.list,
      })
    },
  },
}
</script>

<style lang="less" scoped>
.analysis-alarm-list-total-item-value {
  color: #4FA1F8;
  font-size: 18px;
}
</style>
